import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type StaticListFilter } from '../types/filters';

export const defaultMetricMode = {
  value: 'posting',
  label: 'Unweighted',
  limit: 1,
};
export const METRIC_MODE_OPTIONS = [
  defaultMetricMode,
  { value: 'expected_hires', label: 'Weighted by Expected Hires', limit: 1 },
];

export const metricModeDefinition: FilterDefinition<StaticListFilter> = {
  id: FilterId.METRIC_MODE,
  name: 'Metric Mode',
  selections: [],
  type: FilterType.STATIC_LIST,
  isVisible: true,
};

export const metricModeHandler: FilterHandler<StaticListFilter> = {
  isActive() {
    return true;
  },
  isDefault(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(
    currentFilterState: StaticListFilter,
    definition: FilterDefinition<StaticListFilter>
  ) {
    const isUserSubmitted = !this.isDefault(currentFilterState, definition);

    if (currentFilterState.selections.length > 0) {
      return {
        ...currentFilterState,
        isVisible: isUserSubmitted,
        isUserSubmitted,
      };
    }

    return {
      ...definition,
      selections: [
        {
          id: defaultMetricMode.value,
          name: defaultMetricMode.label,
          limit: defaultMetricMode.limit,
        },
      ],
      isVisible: isUserSubmitted,
      isUserSubmitted,
    };
  },
};
